module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/unicore-masters/unicore-masters.component.css
// module id = ./src/app/unicore-masters/unicore-masters.component.css
// module chunks = main